import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";

import 'react-loading-bar/dist/index.css';
// import Footer from "./Footer";

const context = "Safety.js";
var self = null;
@inject("appStore")
@observer
class Safety extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount = () => {
        self = this;
    }

    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }

    render() {
        return (
            <div>
                <section className="pt-120 pb-90 section-pattern">
                    <div className="container">
                    <div className="section-title">
                                    <h3>Hexa Food's Safety Measures</h3>
                                    

                                </div>
                        <div className="row align-items-center">
                        
                            <div className="col-lg-6 col-md-6 col-sm-12">

                                    <div className="card" >
                                     
                                        <div className="card-body">
                                        {/* <h5 className="card-title">Hexa Food's safety Measures</h5> */}
                                        <span>Your order is safe at every step.</span>
                                        <span>We are following the guidelines laid out by WHO.</span>
                                       
                                        <p className="card-text"></p>

                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-items"> <a className="nav-link active" data-toggle="tab" href="#mission" role="tab"
                                                aria-selected="true"><b>Five Keys to safer food</b></a></li>
                                        </ul>

                                        <div className="tab-content">
                                            <div className="tab-pane fade show active" id="mission" role="tabpanel">

                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item">Keep Clean,Separate raw and cooked,Cook thoroughly,Keep Food at safe temperature,Use Safe water and raw materials.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-items"> <a className="nav-link active" data-toggle="tab" href="#mission" role="tab"
                                                aria-selected="true"><b>What steps are we taking to have it delivered safely?</b></a></li>
                                        </ul>
                                        <div className="tab-content">
                                            <div className="tab-pane fade show active" id="mission" role="tabpanel">

                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item">Sanitise kitchens every few hours,use protective masks.</li>
                                                    <li className="list-group-item">Delivery partners go through daily temperature checks.</li>
                                                    <li className="list-group-item">Before picking up every order, our delivery partners wash/sanitise their hands.</li>
                                                    <li className="list-group-item">Contactless Delivery helps our riders practise social distancing with you.</li>
                                                </ul>   
                                            </div>
                                        </div>
                                    </div>

                                    

                                </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="card" >
                                        <img class="card-img-top" src="assets/custom_icons/food.jpg" width="400px" height="300px"></img>
                                        <div className="card-body">
                                            </div>
                                            </div>
</div>
                            </div>
                            
                        </div>


  </section>
                    </div>
                    );
                }
            }
            
export default withRouter(Safety);


// WEBPACK FOOTER //
// ./src/Pages/Safety.js